<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group label="Sample" :label-cols="2" :horizontal="true">
          <b-form-input
            v-model="sample.identifier"
            type="text"
            placeholder="Sample Name"
            :state="!$v.sample.identifier.$invalid"
            invalid-feedback="Required"
            @change="handleSampleChange"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          label="Animal Type"
          :label-cols="2"
          :horizontal="true"
        >
          <add-on-select
            :selected-item="sample.animal_type"
            :custom-placeholder="'Select Animal Type'"
            :options="animalFedOptions"
            @change="handleAnimalTypeChange"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group label="Add On(s)" label-cols="2">
      <b-button
        v-b-toggle="`addOns-${sample.test_package_sample_id}${submissionId}`"
        :variant="sample.add_ons.length ? 'primary' : 'dark'"
        block
      >
        Options
      </b-button>
      <b-collapse
        :id="`addOns-${sample.test_package_sample_id}${submissionId}`"
        class="mt-2"
      >
        <custom-form-checkbox-group
          v-if="addOns.length"
          v-model="sample.add_ons"
          :lg="2"
          :md="2"
          :options="
            addOns.map((i) => ({ text: i.name, value: i.id, icon: 'cube' }))
          "
          @change="handleSampleChange"
        />
      </b-collapse>
    </b-form-group>
  </div>
</template>
<script>
import CustomFormCheckboxGroup from '@/components/shared/form/CustomFormCheckboxGroup'
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import { validationMixin } from 'vuelidate/src'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import AddOnSelect from '../../misc/AddOnSelect.vue'

export default {
  name: 'ProjectManureSampleFormGroup',
  components: { AddOnSelect, CustomFormCheckboxGroup },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: ''
    },
    sampleId: {
      type: String,
      default: ''
    },
    addOns: {
      type: Array,
      default: () => []
    },
    animalFedOptions: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters({
      submission: 'projectFormStepTwoSubmission'
    }),
    currentSubmission () {
      return this.submission(this.submissionId)
    },
    sampleList () {
      return this.currentSubmission.samples
    },
    sample () {
      return this.sampleList.find(
        (sample) => sample.test_package_sample_id === this.sampleId
      )
    },
    isValid () {
      return this.$v && !this.$v.$invalid
    }
  },
  validations: {
    sample: {
      identifier: { required },
      animal_type: {}
    }
  },
  methods: {
    ...mapActions(['UPDATE_SUBMISSION']),
    handleSampleChange () {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: this.sampleList,
        name: 'samples'
      })
    },
    handleAnimalTypeChange ({ selected }) {
      this.sample.animal_type = selected
      this.handleSampleChange()
    }
  }
}
</script>
